import clsx from "clsx";
import { type FunctionComponent } from "react";
import type { PostListItem } from "~/database/post.model";
import TopHead from "../Top/TopHead";
import PostItem from "./PostItem";
import type { CategoryItemType } from "~/database/category.model";
import FlowRow from "../Common/FlowRow";
import { Link } from "@remix-run/react";
import { PR_COLORS } from "~/utils/const";

interface TopCategoryPostsProps {
  data: {
    data: PostListItem[];
    category: CategoryItemType;
  }[];
  category: CategoryItemType[];
}

const TopCategoryPosts: FunctionComponent<
  TopCategoryPostsProps
> = ({ data, category }) => {
  return (
    <div
      className={clsx("pt-100", "max-md:pt-60")}
    >
      <TopHead>BY CATEGORY</TopHead>
      <div
        className={clsx(
          "border-t",
          "border-black",
          "border-b",
          "py-20",
          "mt-45",
          "max-md:mt-30",
        )}
      >
        <FlowRow>
          <div className={clsx("flex", "gap-0")}>
            {category
              .filter((el) => !el.is_deleted)
              .map((el, i) => {
                return (
                  <div
                    className={clsx(
                      "flex-shrink-0",
                      "text-18",
                      "font-bold",
                      "pr-50",
                    )}
                    key={i}
                  >
                    <Link
                      to={`/categories/${el.id}`}
                    >
                      {el.name}
                    </Link>
                  </div>
                );
              })}
          </div>
        </FlowRow>
      </div>
      <div
        className={clsx(
          "mx-auto mt-45 w-1305",
          "max-md:w-360",
          "max-md:ml-auto",
          "max-md:mr-0",
        )}
      >
        <ul
          className={clsx(
            "grid grid-cols-3 gap-50",
            "max-md:flex",
            "max-md:flex-col",
          )}
        >
          {data?.map((el, i) => {
            return (
              <li key={i}>
                <h3 className={clsx()}>
                  <Link
                    to={`/categories/${el.category.id}`}
                    className={clsx(
                      "text-lg",
                      "font-bold",
                      "max-md:text-16",
                    )}
                  >
                    {el.category.name}
                  </Link>
                </h3>
                <div className={clsx("mt-10")}>
                  <PostItem
                    color={
                      PR_COLORS[
                        i % PR_COLORS.length
                      ]
                    }
                    data={el.data[0]}
                  ></PostItem>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default TopCategoryPosts;
